<template>
  <CommonModal ref="commonModal" compact hide-close-button bottom-aligned @on-close="onClose">
    <div class="size-guide">
      <div class="size-guide__header">
        <div class="size-guide__title-text">{{ title }}</div>
        <button class="size-guide__close-button" type="button" @click="closeModal">
          <UseSvg class="size-guide__close-button-icon" icon="menu-close" />
        </button>
      </div>
      <div class="size-guide__content">
        <div v-for="(item, index) in presetsGrouped" :key="index" class="size-guide__item">
          <img :src="getImageUrl(item.category)" alt="Size Guide" class="size-guide__item-image" />
          <div class="size-guide__item-title">{{ item.category }}</div>
          <div
            class="size-guide__item-sizes"
            :class="{ 'size-guide__item-sizes--single': item.sizes.length === 1 }"
          >
            <div
              v-for="(size, sizeIndex) in item.sizes"
              :key="sizeIndex"
              class="size-guide__item-size"
            >
              <strong v-if="size.sizeRange">{{ size.sizeRange }}</strong>
              <span>{{ size.sizeString }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </CommonModal>
</template>
<script>
import UseSvg from "common/vue/components/UseSvg.vue";
import CommonModal from "common/vue/components/CommonModal.vue";
import { MAX_PRINT_SIZES_GROUPED } from "../common/constants";
import { getTitleCaseString } from "../utils";

export default {
  name: "SizeGuide",
  components: {
    CommonModal,
    UseSvg
  },
  props: {
    preset: {
      type: Array,
      required: true
    }
  },
  emits: ["on-close"],
  computed: {
    title() {
      return getTitleCaseString(this.preset);
    },
    presetList() {
      return MAX_PRINT_SIZES_GROUPED[this.preset];
    },
    presetsGrouped() {
      const categoryMap = new Map();

      this.presetList.forEach(({ category, sizeRange, width, height }) => {
        const sizeObject = {
          sizeRange: sizeRange || null,
          sizeString: `${width}" x ${height}"`
        };

        if (!categoryMap.has(category)) {
          categoryMap.set(category, { category, sizes: [] });
        }

        categoryMap.get(category).sizes.push(sizeObject);
      });

      return Array.from(categoryMap.values());
    }
  },
  methods: {
    getImageUrl(category) {
      return `https://jiffy.imgix.net/gen/preset-sizes/${this.preset}/${category}.png?ixlib=rb-0.3.5&h=400&dpr=2&q=60`;
    },
    onClose() {
      this.$emit("on-close");
    },
    closeModal() {
      this.$refs.commonModal.close();
    }
  }
};
</script>
<style lang="scss" scoped>
@import "frontend/init/jiffy/settings.scss";
@import "frontend/init/jiffy/mixin.scss";

.size-guide {
  $this: &;

  max-width: 100%;
  padding: 15px;

  &__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 24px;
    font-weight: 600;
    margin-bottom: 5px;
  }

  &__close-button {
    background-color: transparent;
    border: none;
    cursor: pointer;
    padding: 0;
    margin: 0;
  }

  &__close-button-icon {
    width: 26px;
    height: 26px;
  }

  &__title-text {
    font-size: 24px;
    font-weight: 700;
    text-align: left;
    margin-bottom: 10px;
  }

  &__content {
    display: flex;
    max-width: 100%;
    overflow-x: auto;
    overflow-y: hidden;
    gap: 10px;
  }

  &__item {
    display: flex;
    flex-direction: column;
    align-items: center;
    flex-shrink: 0;
    gap: 15px;
    background-color: $app-gray-modern-100;
    font-weight: 400;
    width: 250px;
    max-height: 615px;
    padding: 10px;

    @include with-tablet {
      padding: 10px 0;
    }
  }

  &__item-image {
    width: auto;
    height: 400px;
    max-width: 240px;
    object-fit: contain;
  }

  &__item-title {
    height: 32px;
    padding: 8px 16px;
    border-radius: 8px;
    background-color: #262697;
    color: $white;
    font-size: 14px;
    font-weight: 700;
    line-height: 1;
    text-align: center;
    text-transform: capitalize;
  }

  &__item-sizes {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
    padding: 0 20px 10px 20px;
    width: 100%;
    justify-content: center;

    &--single {
      grid-template-columns: 1fr;
    }
  }

  &__item-size {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 2px;
    height: 50px;
    width: 98px;
    border-radius: 4px;
    background-color: $white;
    font-size: 14px;
    text-align: center;

    &:only-child {
      font-weight: 700;
      width: 112px;
      margin: 0 auto;
    }
  }
}
</style>
